import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function useAnalytics() {
    const location = useLocation();

    useEffect(() => {
        if (window.gtag) {
            console.log("📡 Tracking page:", location.pathname + location.search);

            window.gtag("config", "G-SD75YRCGZT", {
                page_path: location.pathname + location.search,
            });
        }
    }, [location]);
}
